import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { DateTime } from 'scaleflow/utils/date-time';

export default class InitiativesProgressPanelFeedItemIndexComponent extends Component {
  @service store;
  @tracked editorEnabled = false;

  get daysAgo() {
    return DateTime.from(this.args.update.created_at).fromNow();
  }

  @action
  deleteUpdate(update) {
    update.destroyRecord();
  }

  @action
  enableEditor() {
    this.editorEnabled = true;
  }

  @action
  deactivate() {}

  @action
  saveUpdateAndDisableEditor(update) {
    update.save().then(() => {
      this.editorEnabled = false;
    });
  }

  @action
  setDelta(e) {
    this.args.update.text_delta = e;
  }

  @action
  handleReportedHealthChange(e) {
    if (!this.editorEnabled) return false;
    else this.args.update.reported_health = e;
  }
}
